export default defineNuxtRouteMiddleware((to, from) => {
    if (
        import.meta.server
        && typeof to.query.programma === 'string'
    ) {
        return navigateTo('/programma/' + decodeURIComponent(to.query.programma), {
            replace: true,
        });
    }

    if (
        import.meta.server
        && typeof to.query.productie === 'string'
    ) {
        return navigateTo(`/programma/${decodeURIComponent(to.query.productie)}`, {
            replace: true,
        });
    }

    if (import.meta.server) {
        return;
    }

    const modalStore = useModalStore();

    if (     
        !to.query.productie
        && !to.query.programma
    ) {
        // console.warn('closed all modals');
        modalStore.closeAll();
    }

    if (from.query.productie && to.query.programma) {
        // console.warn('closed event content modal');

        modalStore.close(MODAL_EVENT_CONTENT);
    } else if (from.query.programma && to.query.productie) {
        // console.warn('closed event date modal');

        modalStore.close(MODAL_MAIN);
    }
});
